<template>
  <uiv-modal v-model="open" size="sm" :title="`${electricVehicle ? 'Electric' : 'Your'} Vehicle`" @hide="onCloseModal"
    append-to-body>

    <vehicle-thumbnail :src="vehicle.image" />

    <div v-show="showStep('makeId')">
      <label for="vehicleMake" v-if="!form.makeId">
        What is the make of {{ electricVehicle ? 'the electric' : 'your' }}
        vehicle?
      </label>
      <label for="vehicleMake" v-else>Make</label>
      <div class="row" v-show="!loadingMakes">
        <div class="col-xs-12">
          <validation-messages :label="`${electricVehicle ? 'Electric' : 'Vehicle'} Make`" :$v="$v.form.makeId">
            <search-select-list placeholder="Start Typing Your Vehicle" id="vehicleMake" ref="make"
              :select-list="vehicleMakeList" label-key="makeName" label-value="makeId" @onChoose="onChooseMake"
              :error="$v.form.makeId.$error">
              {{ vehicle.make }}
            </search-select-list>
          </validation-messages>
        </div>
      </div>
    </div>

    <div class="_margin-top-20" v-show="showStep('modelId')">
      <label for="vehicleModel" v-if="!form.modelId">
        What is the model of {{ electricVehicle ? 'the electric' : 'your' }} vehicle?
      </label>
      <label for="vehicleModel" v-else>Model</label>

      <div class="row" v-show="!loadingModels">
        <div class="col-md-12">
          <validation-messages :label="`${electricVehicle ? 'Electric' : 'Vehicle'} Model`" :$v="$v.form.modelId">
            <select-list id="vehicleModel" v-model="form.modelId" :list="vehicleModelList" label-key="model"
              value-key="modelId" :error="$v.form.modelId.$error" @change="onChooseModel" />
          </validation-messages>
        </div>
      </div>
    </div>

    <!-- <div class="_margin-top-20" v-show="showStep('engineSize')">
      <label for="vehicleEngine">{{ electricVehicle ? 'Battery Size' : 'Power Output' }}</label>
      <div class="row" v-show="!loadingEngines">
        <div class="col-md-12">
          <validation-messages :label="`${electricVehicle ? 'Electric' : 'Vehicle'} Engine`" :$v="$v.form.engineSize">
            <select-list id="vehicleEngine" v-model="form.engineSize" :list="vehicleEngineList" value-key="engineSize"
              label-key="engineSizeWithUnits" :error="$v.form.engineSize.$error" @change="onChooseEngine" />
          </validation-messages>
        </div>
      </div>
    </div> -->

    <div class="_margin-top-20 text-center">
      <loader :show="loadingMakes"></loader>
      <loader :show="loadingModels"></loader>
    </div>

    <div slot="footer">
      <uiv-btn @click="cancel = true; open = false">Cancel</uiv-btn>

      <uiv-btn type="primary" @click="onDone">Done</uiv-btn>
    </div>
  </uiv-modal>
</template>

<script>
import { mapState } from 'vuex';
import VehicleThumbnail from '../../vehicle-thumbnail/VehicleThumbnail';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'NoRegistrationVehicle',
  data() {
    return {
      requesting: false,
      form: {
        makeId: null,
        modelId: null,
        engineSize: null
      },
      vehicle: {},
      cancel: false,
      open: false
    };
  },
  props: {
    electricVehicle: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    form: {
      makeId: { required },
      modelId: { required },
      engineSize: { required }
    }
  },
  computed: {
    ...mapState({
      vehicleMakeList: ({ lookups }) => lookups.vehicleMakes,
      vehicleModelList: ({ lookups }) => lookups.vehicleModels,
      vehicleEngineList: ({ lookups }) => lookups.vehicleEngines,
      loadingMakes: ({ lookups }) => lookups.requesting.vehicleMakes,
      loadingModels: ({ lookups }) => lookups.requesting.vehicleModels,
      loadingEngines: ({ lookups }) => lookups.requesting.vehicleEngines
    })
  },
  methods: {
    async openModal() {
      const { electricVehicle } = this;

      this.$v.form.$reset();
      this.open = true;
      this.cancel = false;
      this.form.makeId = null;
      this.form.modelId = null;
      this.form.engineSize = null;
      this.vehicle = {};
      this.$refs.make.onReset();
      await this.$store.dispatch('lookups/getVehicleMakes', { electricVehicle });
    },
    async onChooseMake(val) {
      if (!val) return;
      const { electricVehicle } = this;

      this.vehicle = { make: val.makeName };
      this.form.makeId = val.makeId;
      this.form.modelId = null;
      this.form.engineSize = null;

      await this.$store.dispatch('lookups/getVehicleModels', {
        id: val.makeId, electricVehicle
      });
    },
    async onChooseModel(val) {
      if (!val) return;

      const { electricVehicle } = this;
      this.form.engineSize = null;
      const vehicle = await this.$store.dispatch('lookups/getVehicleDetails', this.form);
      this.vehicle = vehicle;
      await this.$store.dispatch('lookups/getVehicleEngines', {
        id: this.form.modelId, electricVehicle
      });

      this.onChooseEngine(this.vehicleEngineList[0].engineSize);
    },
    onChooseEngine(val) {
      if (val == null) return;

      if (this.electricVehicle) {
        this.vehicle.batterySize = val;
      } else {
        this.vehicle.engineSize = val;
      }

      this.form.engineSize = val;
    },
    onCloseModal() {
      if (this.cancel) {
        return this.$emit('onClose', false);
      }

      if (this.form.makeId && this.form.modelId) {
        this.$emit('onClose', this.vehicle);
      }
    },
    onDone() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      this.open = false;
    },
    showStep(step) {
      const conditions = {
        makeId: true,
        modelId: !this.$v.form.makeId.$invalid
      };

      return conditions[step];
    }
  },
  components: {
    VehicleThumbnail
  }
};
</script>

<style lang="scss" scoped></style>
